export const GET_SEMI_PRODUCT_BY_READY = 'GET_SEMI_PRODUCT_BY_READY';
export const GET_SEMI_PRODUCT_BY_READY_SUCCESS = 'GET_SEMI_PRODUCT_BY_READY_SUCCESS';
export const GET_SEMI_PRODUCT_BY_READY_FAIL = 'GET_SEMI_PRODUCT_BY_READY_FAIL';
export const CLEAR_CORRECTION_SEMI_PRODUCTS = 'CLEAR_CORRECTION_SEMI_PRODUCTS';

export const GET_CORRECTION_SEMI = 'GET_CORRECTION_SEMI';
export const GET_CORRECTION_SEMI_SUCCESS = 'GET_CORRECTION_SEMI_SUCCESS';
export const GET_CORRECTION_SEMI_FAIL = 'GET_CORRECTION_SEMI_FAIL';
